import { Badge } from "../Badge"
import {
  ACCESS_STATUS,
  ACCESS_STATUS_BADGE_VARIANTS,
  ACCESS_STATUS_LABELS,
} from "../../constants/accessStatus"

export const AccessStatusBadge = ({ status }) => {
  if (!status || status === ACCESS_STATUS.NOT_APPLICABLE) {
    return <span className="text-gray-400">—</span>
  }

  return (
    <Badge
      variant={ACCESS_STATUS_BADGE_VARIANTS[status] || "locked"}
      text={ACCESS_STATUS_LABELS[status] || status}
    />
  )
}
